import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RouteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"route"}/>
}
